import React from "react";
import { Link } from "react-router-dom";
import About from "./layouts/About/About";
import ContactUs from "./layouts/Contact/ContactUs";
import Carousel from "./layouts/carousel/Carousel";
import PricingModal from "./layouts/Pricing/PricingModal";
import Carousel_slider from "./layouts/Carousel_slider/Carousel_slider";
import "./index.css";
import Mini_carousel1 from "./layouts/mini_carousel1/Mini_carousel1";
import FAQ from "./layouts/FAQs/FAQ";

const Home = () => {
  return (
    <div>
      <section className="menu menu2 cid-ugMsAd1w6t" id="menu-5-ugMsAd1w6t">
        <nav className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg">
          <div className="container">
            <div className="navbar-brand">
              <span className="navbar-logo">
                <a href="https://itscglobal.com/" target="_blank" rel="noopener noreferrer" >
                  <img
                    src="assets/images/logo.jpg"
                    alt=""
                    style={{ height: "3.3rem" }}
                  />
                </a>
              </span>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-bs-toggle="collapse"
              data-target="#navbarSupportedContent"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <div className="hamburger">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul
                className="navbar-nav nav-dropdown nav-right"
                data-app-modern-menu="true"
              >
                <li className="nav-item">
                  <a className="nav-link link text-black display-4" href="#">
                    Home
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link link text-black display-4"
                    href="#article12-l"
                    aria-expanded="false"
                  >
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link link text-black display-4"
                    href="#contacts-11-ugMsAd4jXN"
                  >
                    Contact Us
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link link text-black display-4"
                    href="#faq-1-ugMsAd4ZPC"
                  >
                    FAQs
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link link text-black display-4"
                    href="#pricing04-o"
                  >
                    Pricing
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </section>

      <Carousel_slider />

      <section className="features03 cid-ugMsAd4UfD" id="news-1-ugMsAd4UfD">
        <div className="container-fluid">
          <div className="row justify-content-center mb-5">
            <div className="col-12">
              <div className="mbr-section-head">
                {/* <h3 class="mbr-section-title mbr-fonts-style align-center mb-0 display-5"><strong style="border-bottom: 4px solid rgb(42, 111, 151);">Revolutionizing Healthcare Management</strong></h3> */}
                <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                  <strong className="heading-border">Compliances</strong>
                </h4>
              </div>
            </div>
          </div>

          <div className="row d-flex justify-content-around">
            <div className="item features-image col-6 col-sm-6 col-md-6 col-lg-3 glass-shine-effect">
              <a href="https://loinc.org/" target="_blank">
                <div className="item-wrapper">
                  <div className="item-img mb-3">
                    <img
                      src="assets/images/loinc-logo-tmp.png"
                      alt=""
                      title=""
                    />
                  </div>
                </div>
              </a>
            </div>

            <div className="item features-image col-6 col-sm-6 col-md-6 col-lg-3 glass-shine-effect">
              <a href="https://icd.who.int/en" target="_blank">
                <div className="item-wrapper">
                  <div className="item-img mb-3">
                    <img
                      src="assets/images/icd10_233993415.png"
                      alt=""
                      title=""
                      data-slide-to={1}
                      data-bs-slide-to={1}
                    />
                  </div>
                </div>
              </a>
            </div>

            <div className="item features-image col-6 col-sm-6 col-md-6 col-lg-3 glass-shine-effect">
              <a
                href="https://www.snomed.org/what-is-snomed-ct"
                target="_blank"
              >
                <div className="item-wrapper">
                  <div className="item-img mb-3">
                    <img
                      src="assets/images/snomedct_392737331.png"
                      alt=""
                      title=""
                      data-slide-to={2}
                      data-bs-slide-to={2}
                    />
                  </div>
                </div>
              </a>
            </div>

            <div className="item features-image col-6 col-sm-6 col-md-6 col-lg-3 glass-shine-effect">
              <a href="https://www.hl7.org/" target="_blank">
                <div className="item-wrapper">
                  <div className="item-img mb-3">
                    <img
                      src="assets/images/hl7_611717313.png"
                      alt=""
                      title=""
                      data-slide-to={2}
                      data-bs-slide-to={2}
                    />
                  </div>
                </div>
              </a>
            </div>

            <div className="item features-image col-6 col-sm-6 col-md-6 col-lg-3 glass-shine-effect">
              <a href="https://abdm.gov.in/" target="_blank">
                <div className="item-wrapper">
                  <div className="item-img mb-3">
                    <img
                      src="assets/images/abdm.png"
                      alt=""
                      title=""
                      data-slide-to={2}
                      data-bs-slide-to={2}
                    />
                  </div>
                  {/* <div className="item-content align-center">
                <h4 className="item-title mbr-fonts-style mb-2 mt-0 display-5">
                  <strong>( HL-7 )</strong>
                </h4>

                <p className="mbr-text mbr-fonts-style mb-3 display-7"
                  style={{ textAlign: "justify", padding: 18, fontSize: 20 }}>
                  Health Level Seven International (HL7) is a non-profit, ANSI-accredited standards development
                  organisation.

                </p>
                <div className="mbr-section-btn item-footer">
                  <a href="https://www.hl7.org/" className="btn item-btn btn-primary display-7">
                    Read
                  </a>
                </div>
              </div> */}
                </div>
              </a>
            </div>

            <div className="item features-image col-6 col-sm-6 col-md-6 col-lg-3 glass-shine-effect">
              <a
                href="https://ecqi.healthit.gov/fhir?qt-tabs_fhir=about"
                target="_blank"
              >
                <div className="item-wrapper">
                  <div className="item-img mb-3">
                    <img
                      src="assets/images/fhir.png"
                      alt=""
                      title=""
                      data-slide-to={2}
                      data-bs-slide-to={2}
                    />
                  </div>
                </div>
              </a>
            </div>

            <div className="item features-image col-6 col-sm-6 col-md-6 col-lg-3 glass-shine-effect">
              <a href="https://nha.gov.in/" target="_blank">
                <div className="item-wrapper">
                  <div className="item-img mb-3">
                    <img
                      src="assets/images/nha.jpg"
                      alt=""
                      title=""
                      data-slide-to={2}
                      data-bs-slide-to={2}
                    />
                  </div>
                  {/* <div className="item-content align-center">
                <h4 className="item-title mbr-fonts-style mb-2 mt-0 display-5">
                  <strong>( HL-7 )</strong>
                </h4>

                <p className="mbr-text mbr-fonts-style mb-3 display-7"
                  style={{ textAlign: "justify", padding: 18, fontSize: 20 }}>
                  Health Level Seven International (HL7) is a non-profit, ANSI-accredited standards development
                  organisation.

                </p>
                <div className="mbr-section-btn item-footer">
                  <a href="https://www.hl7.org/" className="btn item-btn btn-primary display-7">
                    Read
                  </a>
                </div>
              </div> */}
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section
        className="article13 cid-ugMsAd2u24"
        id="call-to-action-5-ugMsAd2u24"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="card col-md-12 col-lg-12">
              <div className="card-wrapper">
                <div className="card-box align-center">
                  <h4 className="card-title mbr-fonts-style display-3">
                    <strong>Transform Your Healthcare Experience Today</strong>
                  </h4>
                  <p className="text-sm-start mbr-text mbr-fonts-style mt-4 display-7 text-justify">
                    In a rapidly evolving world, the healthcare industry is
                    embracing innovation to offer patients and providers a
                    seamless, efficient, and personalized experience.
                    Transforming your healthcare experience means going beyond
                    traditional methods and adopting cutting-edge technologies
                    and systems that prioritize convenience, accuracy, and
                    accessibility.
                  </p>
                  <p className="text-sm-start mbr-text mbr-fonts-style mt-4 display-7 text-justify">
                    Ready to revolutionize your healthcare institution. Discover
                    the power of ITSC HMIS (eSehat) and take your operations to
                    the next level!
                  </p>
                  <div className="mbr-section-btn mt-4">
                    <a
                      className="btn btn-white-outline display-4"
                      href="#pricing04-o"
                    >
                      Get Started
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="article12 cid-ugNpKtqSGX text-center"
        id="article12-l"
      >
        <About />
      </section>

      <section
        data-bs-version="5.1"
        className="gallery4 cid-ugMsAd2jpx"
        id="gallery-12-ugMsAd2jpx"
      >
        <div
          className="container-fluid gallery-wrapper"
          id="gallery-12-asAHGgad"
        >
          <div className="row justify-content-center">
            <div className="col-12 content-head"></div>
          </div>

          <Mini_carousel1 />

          {/* <div className="grid-container">
            <div className="grid-container-1" style={{ transform: 'translate3d(-200px, 0px, 0px)' }}>
              <div className="grid-item">
                <img src="assets/images/Slide/carousel1.png"
                  alt="image" />
              </div>
              <div className="grid-item">
                <img src="assets/images/Slide/carousel2.png"
                  alt="image" />
              </div>
              <div className="grid-item">
                <img src="assets/images/Slide/carousel3.png"
                  alt="image" />
              </div>
              <div className="grid-item">
                <img src="assets/images/Slide/carousel4.png"
                  alt="image" />
              </div>
            </div>
            <div className="grid-container-2" style={{ transform: 'translate3d(-70px, 0px, 0px)' }}>
              <div className="grid-item">
                <img src="assets/images/Slide/carousel5.png"
                  alt="image" />
              </div>  
              <div className="grid-item">
                <img src='assets/images/Slide/carousel9.png'
                  alt="image" />
              </div>
              <div className="grid-item">
                <img src="assets/images/Slide/carousel8.png"
                  alt="image" />
              </div>
              <div className="grid-item">
                <img src="assets/images/Slide/carousel15.png"
                  alt="image" />
              </div>
            </div>
          </div> */}
        </div>
      </section>

      <section className="features5 cid-ugMsAd2hZD" id="features-24-ugMsAd2hZD">
        <div className="container">
          <div className="row mb-5 justify-content-center">
            <div className="col-12 col-lg-11">
              {/* <h3 class="mbr-section-title mbr-fonts-style mb-4 mt-0 display-3"><strong style="border-bottom: 4px solid rgb(42, 111, 151);">Unleash Healthcare Potential</strong></h3> */}

              <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                <strong className="heading-border">
                  Redefining Healthcare Management
                </strong>
              </h4>

              <p className="mbr-section-subtitle mbr-fonts-style align-center mb-0 mt-4 display-7 text-justify">
                {/* Empowering Healthcare Institutions with Cutting-Edge Solutions */}
                Healthcare is evolving—and so is the way we manage it. e-sehat brings a modern, tech-driven approach to healthcare management, making patient care more efficient, accessible, and effective. From digital records to streamlined operations, we’re setting new standards in how healthcare works.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb active">
              <div className="item-wrapper ">
                <div className="card-box align-center hover-effect card-design">
                  <i className="fa fa-money fa-4x icon-color" />
                  <p className="card-title mbr-fonts-style mt-0 mb-3 display-5">
                    <strong>Financial Control</strong>
                  </p>
                  <p className="card-text mbr-fonts-style display-7">
                    Streamline financial processes for efficient operations.
                  </p>
                </div>
              </div>
            </div>

            <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
              <div className="item-wrapper ">
                <div className="card-box align-center hover-effect card-design">
                  {/* <FontAwesomeIcon icon={faPhone} style={{ fontSize: '24px', color: 'blue' }} /> */}
                  <i class="fa fa-user-plus fa-4x icon-color"></i>
                  <p className="card-title mbr-fonts-style mt-0 mb-3 display-5">
                    <strong>ADT/Registration</strong>
                  </p>
                  <p className="card-text mbr-fonts-style display-7">
                    Uncover deep clinical data for informed decision-making.
                  </p>
                </div>
              </div>
            </div>

            <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
              <div className="item-wrapper">
                <div className="card-box align-center hover-effect card-design">
                  <i class="fa fa-cogs fa-4x icon-color" aria-hidden="true"></i>
                  <p className="card-title mbr-fonts-style mt-0 mb-3 display-5">
                    <strong>Administrative Ease</strong>
                  </p>
                  <p className="card-text mbr-fonts-style display-7">
                    Simplify administrative tasks for seamless workflow.
                  </p>
                </div>
              </div>
            </div>

            <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
              <div className="item-wrapper">
                <div className="card-box align-center hover-effect card-design">
                  <i
                    class="fa fa-desktop fa-4x icon-color"
                    aria-hidden="true"
                  ></i>
                  <p className="card-title mbr-fonts-style mt-0 mb-3 display-5">
                    <strong>User-Friendly Interface</strong>
                  </p>
                  <p className="card-text mbr-fonts-style display-7">
                    Intuitive design for easy navigation and accessibility.
                  </p>
                </div>
              </div>
            </div>
            <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
              <div className="item-wrapper">
                <div className="card-box align-center hover-effect card-design">
                  <i
                    class="fa fa-globe fa-4x icon-color"
                    aria-hidden="true"
                  ></i>
                  <p className="card-title mbr-fonts-style mt-0 mb-3 display-5">
                    <strong>Geographical Integration</strong>
                  </p>
                  <p className="card-text mbr-fonts-style display-7">
                    Connect multiple locations for centralized management.
                  </p>
                </div>
              </div>
            </div>
            <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
              <div className="item-wrapper" style={{ borderColor: "red" }}>
                <div className="card-box align-center hover-effect card-design">
                  <i
                    class="fa fa-bar-chart fa-4x icon-color"
                    aria-hidden="true"
                  ></i>
                  <p className="card-title mbr-fonts-style mt-0 mb-3 display-5">
                    <strong>Predictive Analytics</strong>
                  </p>
                  <p className="card-text mbr-fonts-style display-7">
                    Harness the power of data for future insights.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        data-bs-version="5.1"
        className="features023 cid-ugMsAd3NVM"
        id="metrics-1-ugMsAd3NVM"
      >
        <div className="container cid-ugMsAd2u24">
          <div className="card-wrapper">
            <div className="row content-row justify-content-center">
              <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
                <div className="item-wrapper card-design3">
                  <div className="title mb-2 mb-md-3 ">
                    <span className="num mbr-fonts-style display-1">
                      <strong style={{ color: "white" }}>98%</strong>
                    </span>
                  </div>
                  <h4 className="card-title mbr-fonts-style display-5">
                    <strong>Clinical Accuracy</strong>
                  </h4>
                </div>
              </div>
              <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
                <div className="item-wrapper card-design3">
                  <div className="title mb-2 mb-md-3">
                    <span className="num mbr-fonts-style display-1">
                      <strong style={{ color: "white" }}>5M+</strong>
                    </span>
                  </div>
                  <h4 className="card-title mbr-fonts-style display-5">
                    <strong>Patients Managed</strong>
                  </h4>
                </div>
              </div>
              <div className="item features-without-image col-12 col-md-6 col-lg-4 item-mb">
                <div className="item-wrapper card-design3">
                  <div className="title mb-2 mb-md-3">
                    <span className="num mbr-fonts-style display-1">
                      <strong style={{ color: "white" }}>24/7</strong>
                    </span>
                  </div>
                  <h4 className="card-title mbr-fonts-style display-5">
                    <strong>Support Availability</strong>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section data-bs-version="5.1" className="gallery10 cid-ugMsAd4Mdm" id="features-61-ugMsAd4Mdm">
    <div className="container-fluid">
      <div className="loop-container" style={{
      position: "relative",
      display: "inline-flex",
      whiteSpace: "nowrap",
      transform: "translateX(-67.9%)"
    }}>
        <div className="item display-1"
          data-linewords="Efficient Management * Streamlined Processes * Enhanced Productivity * Seamless Integration * Advanced Analytics * Customizable Solutions *"
          data-direction={-1} data-speed="0.05">
          ☁️ Best offers ☁️ Free delivery ☁️ Perfect design ☁️ Comfort ☁️
          Support 24/7 ☁️ Vibes
        </div>
        <div className="item display-1"
          data-linewords="Efficient Management * Streamlined Processes * Enhanced Productivity * Seamless Integration * Advanced Analytics * Customizable Solutions *"
          data-direction={-1} data-speed="0.05">
          ☁️ Best offers ☁️ Free delivery ☁️ Perfect design ☁️ Comfort ☁️
          Support 24/7 ☁️ Vibes
        </div>
      </div>
    </div>
  </section> */}

      <section
        data-bs-version="5.1"
        className="pricing04 startm5 cid-uhD0w7kbES px-3"
        id="pricing04-o"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="col-12 col-md-12 row">
                <div className="col-12 hdr_price">
                  <h5 className="text-center mbr-section-title mbr-fonts-style mt-0 mb-2 display-2">
                    <strong className="heading-border">
                      Select Your Package
                    </strong>
                  </h5>
                  <p className="mbr-section-subtitle mbr-fonts-style mt-4 mb-4 display-7">
                    {/* Browse pricing plans or schedule your free consultation to
                    find the perfect solution. */}
                    Explore our pricing plans or book a free consultation to
                    discover the ideal solution for you.
                  </p>
                </div>

                {/* <div className="mbr-section-btn mt-3 main-button col-4">
              <a href="#contact-form-3-ugMsAd4paT  " className="btn btn-primary display-7">
                Know Features
              </a>
            </div> */}
              </div>
            </div>
            <div className="col-lg-12 side-features row">
              <div className="table-responsive">
                <table className="table table-striped text-successtable-border border-light">
                  <thead
                    className="border-light "
                    style={{ background: "#2a6f97" }}
                  >
                    <tr>
                      <th
                        scope="col"
                        className="text-center price-head-akjfh"
                        style={{ color: "#fefe" }}
                      >
                        <strong>PLANS</strong>
                      </th>
                      <th
                        scope="col"
                        className="text-center price-head-akjfh"
                        style={{ color: "#fefe" }}
                      >
                        <strong>STARTER / FREE</strong>
                      </th>
                      <th
                        scope="col"
                        className="text-center price-head-akjfh"
                        style={{ color: "#fefe" }}
                      >
                        <strong>BASIC</strong>
                      </th>
                      <th
                        scope="col"
                        className="text-center price-head-akjfh"
                        style={{ color: "#fefe" }}
                      >
                        <strong>STANDARD</strong>
                      </th>
                      <th
                        scope="col"
                        className="text-center price-head-akjfh"
                        style={{ color: "#fefe" }}
                      >
                        <strong>ADVANCE</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">SUITABLE FOR</th>
                      <td className="fw-bold text-center">Private Clinics</td>
                      <td className="fw-bold text-center">
                        Small Hospitals, Nursing Homes, IVF
                      </td>
                      <td className="fw-bold text-center">
                        Small To Medium Hospital
                      </td>
                      <td className="fw-bold text-center">
                        Large Size hospitals{" "}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">SPACE ON CLOUDS</th>
                      <td className="fw-bold text-center">500MB</td>
                      <td className="fw-bold text-center">1 GB</td>
                      <td className="fw-bold text-center">Offline</td>
                      <td className="fw-bold text-center">Offline</td>
                    </tr>
                    <tr>
                      <th scope="row">TYPES</th>
                      <td className="text-center">Clinic/OPD</td>
                      <td className="text-center">20 Beds</td>
                      <td className="text-center">20 - 50 Beds</td>
                      <td className="text-center">50 - 200 Beds</td>
                    </tr>

                    <tr>
                      <th scope="row">No. OF USERS</th>

                      <td className="text-center">10</td>
                      <td className="text-center">15</td>
                      <td className="text-center">30</td>
                      <td className="text-center">No Restriction</td>
                    </tr>

                    <tr>
                      <th scope="row">PLATFORM</th>

                      <td className="text-center">SaaS</td>
                      <td className="text-center">Online/Offline</td>
                      <td className="text-center">Offline</td>
                      <td className="text-center">Offline</td>
                    </tr>

                    <tr>
                      <th className="text-center fw-bold" colSpan={6}>
                        <h6 className=" fw-bold">MODULES</h6>
                      </th>
                    </tr>
                    <tr>
                      <th scope="row">ONLINE APPOINTMENT</th>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">ABDM</th>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">REGISTRATION</th>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">OPD/CONSULTATION</th>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">IPD/NURSING</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center"> BASIC</td>
                      <td className="text-center"> STANDARD</td>
                      <td className="text-center"> ADVANCE</td>
                    </tr>
                    <tr>
                      <th scope="row">SERVICE ORDER</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">INTEGRATED PHARMACY</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center"> Add-on</td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />{" "}
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />{" "}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">MATERIAL MANAGEMENT</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row ">
                        INHOUSE LAB <span>(Manual)</span>
                      </th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center"> Add-on</td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />{" "}
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />{" "}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        {" "}
                        RADIOLOGY <span>(Manual)</span>
                      </th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">Add-on</td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">RADIOLOGY WITH PACS</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center"> Add-on</td>
                      <td className="text-center"> Add-on </td>
                    </tr>

                    <tr>
                      <th scope="row">LAB ANALYZER INTEGRATION</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">Add-on</td>
                      <td className="text-center"> Add-on</td>
                      <td className="text-center"> Add-on </td>
                    </tr>

                    <tr>
                      <th scope="row">OT</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">CSD</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">BIO MEDICAL</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">LAUNDRY</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">MRD/EHR</th>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">AMBULANCE</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">BLOOD BANK</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">HR+PAYROLL</th>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center">
                        <i className="fa fa-times-circle red-check" />
                      </td>
                      <td className="text-center"> Add-on</td>
                      <td className="text-center"> Add-on </td>
                    </tr>

                    <tr>
                      <th scope="row">CUSTOMIZATION</th>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-times-circle red-check" />{" "}
                      </td>
                      <td className="text-center">Add-on</td>
                      <td className="text-center">Add-on</td>
                      <td className="text-center"> New Features Add-On</td>
                    </tr>

                    <tr>
                      <th scope="row">MIS DASHBOARD</th>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">BILLING</th>
                      <td className="text-center">MANUAL</td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                      <td className="text-center">
                        {" "}
                        <i className="fa fa-check-circle green-check" />
                      </td>
                    </tr>

                    <tr>
                      <th className />
                      <th className="text-center">
                        <PricingModal
                          heading="START PLAN FOR FREE"
                          head="Contact Us"
                        />
                      </th>
                      <th className="text-center">
                        <PricingModal heading="BASIC PLAN" head="Contact Us" />
                      </th>
                      <th className="text-center">
                        <PricingModal
                          heading="STANDARD PLAN"
                          head="Contact Us"
                        />
                      </th>
                      <th className="text-center">
                        <PricingModal
                          heading="ADVANCE PLAN"
                          head="Contact Us"
                        />
                      </th>
                      <th className />
                    </tr>

                    <tr>
                      <th colSpan={6} scope="row">
                        <li>Add-on functionality is optional and chargeable</li>
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={6} scope="row">
                        <li>
                          Hospital has to complete the HFR & HPR registration
                          For ABDM
                        </li>
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={6} scope="row">
                        <li>Customization fee is charged separately</li>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="clients04 cid-ugMsAd3i7J" id="partners-1-ugMsAd3i7J">
        <div className="container-fluid">
          <div className="row justify-content-center mb-5">
            <div className="col-12 content-head">
              <div className="mbr-section-head">
                <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                  <strong className="heading-border">Trusted Partners</strong>
                </h4>
              </div>
            </div>
          </div>
          <Carousel />
        </div>
      </section>

      <section
        className="list1 cid-ugMsAd4ZPC d-flex justify-content-center"
        id="faq-1-ugMsAd4ZPC"
      >
      <FAQ />
      </section>

      <section
        className="contacts03 cid-ugMsAd4jXN"
        id="contacts-11-ugMsAd4jXN"
      >
        <ContactUs />
      </section>

      {/* <Policy /> */}

      <scroll-gallery />
      <div className="scroll-watcher"></div>
    </div>
  );
};

export default Home;
